import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
export var FormLabel = function FormLabel(_ref) {
  var caption = _ref.caption,
      children = _ref.children,
      disabled = _ref.disabled,
      className = _ref.className,
      _ref$is = _ref.is,
      Tag = _ref$is === void 0 ? 'label' : _ref$is,
      tooltip = _ref.tooltip,
      rest = _objectWithoutProperties(_ref, ["caption", "children", "disabled", "className", "is", "tooltip"]);

  var commonProps = {
    className: cx('tds-form-label', {
      'tds--disabled': disabled
    }, className)
  };
  return React.createElement(React.Fragment, null, tooltip ? React.createElement("div", _objectSpread({}, commonProps), React.createElement(Tag, _objectSpread({
    className: "tds-form-label-text"
  }, rest), children), !!tooltip && React.createElement(React.Fragment, null, " ", tooltip)) : React.createElement(Tag, _objectSpread(_objectSpread({}, commonProps), rest), children), caption && React.createElement("div", {
    className: "tds-form-caption"
  }, caption));
};